<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Mitarbeiter</h1>
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <employee-table @changed="getEmployees" title="Mitarbeiter"></employee-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeTable from '@/views/Tables/EmployeeTable';
import StatsCard from '@/components/Cards/StatsCard';

export default {
    name: "Employees",
    components: {
        StatsCard,
        EmployeeTable,
    },
    methods: {
        getEmployees(data) {
            this.employees = data.data;
            this.total = data.recordsTotal.toString();
        }
    },
    computed: {
        sections() {
            let sections = {}
            this.employees.map(item => {
                sections[item.shortScope] = (sections[item.shortScope] || 0) + 1;
            });
            return sections;
        },
    },
    data() {
        return {
            value: 1,
            employees: [],
            total: '0',
        };
    },
}
</script>

<style scoped>
.card-profile-stats {
    padding: 0.4em 0.8em 0 0;
    margin-bottom: 0.4em;
}

.card-profile-stats > div {
    text-align: center;
    padding: 0.1em 1.2em 0 1.2em;
    margin-bottom: 0;
}

@media (max-width: 1700px) {
    .card-profile-stats > div {
        text-align: center;
        padding: 0.1em 0.8em 0 0;
        margin-bottom: 0;
    }
}

.sectionIcon {
    top: 1.5em;
    position: absolute;
    right: 1em;
}
</style>
